import React, { Component } from 'react'
import { i18n } from '../../validator'
import Button from '../../front/components/shared/sn-button'
import { setOnBoardingStepAction } from '../../admin/actions/on-boarding'
import inOnBoarding, {
    ON_BOARDING_STEP_WELCOME,
    ON_BOARDING_STEP_SPORT,
} from './hoc'

@i18n()
@inOnBoarding(ON_BOARDING_STEP_WELCOME)
export default class WelcomeOnBoarding extends Component {

    /**
     * Go to next step
     */
    gotoNextStep = () => {
        setOnBoardingStepAction(ON_BOARDING_STEP_SPORT)
    }

    render = () => {
        const { t } = this.props

        return (
            <div className="d-flex flex-column">
                <span className="text-color-gray-dark-1 font-weight-bold font-size-xl">{t('onBoardingWelcomeTitle')}</span>
                <span className="text-color-gray-dark-1 font-size-sm">{t('onBoardingWelcomeSubtitle')}</span>
                <div className="mt-4">
                    <Button
                        className="btn btn-color-brand btn-circle"
                        onClick={this.gotoNextStep}
                    >
                        {t('onBoardingWelcomeButtonStart')}
                    </Button>
                </div>
            </div>
        )
    }
}
